import {useTranslation} from 'react-i18next';
import {convertVariablesToHtml} from '../../../component/textEditor/Variables';
import {useVariables} from '../../../assets/objects/Variables';
import {serializeTemplateStructure} from '../../whatsAppTemplateEditor/utils/formatUtils';

interface UseMessageContentProps {
    currentTab: string;
    whatsappProps?: any;
    smsProps?: any;
    emailProps?: any;
    variablesType: string;
}

export function useMessageContent({currentTab, whatsappProps, smsProps, emailProps, variablesType}: UseMessageContentProps) {
    const {t: tVariables} = useTranslation('variables');
    const {defaultVariables} = useVariables(variablesType);

    const getMessageContent = () => {
        let content = '';
        let subject = '';
        
        switch (currentTab) {
            case 'whatsapp': {
                content = serializeTemplateStructure(whatsappProps?.whatsappTemplate ?? []);
                break;
            }
            case 'sms':
                content = smsProps?.message || '';
                break;
            case 'email':
                content = emailProps?.emailBody || '';
                subject = emailProps?.emailSubject || '';
                break;
            default:
                return '';
        }
        
        const processedContent = convertVariablesToHtml(content, defaultVariables, tVariables);
        let result = processedContent;
        
        // Add email subject if it's email mode
        if(currentTab === 'email' && subject) {
            const processedSubject = convertVariablesToHtml(subject, defaultVariables, tVariables);
            result = `<p>${processedSubject}</p><br/><p>${result}</p>`;
            return result;
        }
        
        return result;
    };

    return {
        getMessageContent
    };
}
